import WYSIWYG from '@components/ui/WYSIWYG'

interface Props {
  slice: any
}

const ColourPdpBenefits = ({ slice }: Props) => {
  return (
    <div className="bg-brand-light-grey w-full">
      <div className="wrapper py-16 grid lg:grid-cols-2 grid-cols-1">
        {slice?.primary?.title && (
          <div className="font-roboto font-light align-top mb-8 lg:mb-0 text-mobileh1 lg:text-h1 text-brand-dark-grey max-w-5xl text-left lg:pr-8">
            {slice.primary.title}
          </div>
        )}
        <div>
          {slice?.items?.map((item: any, i: number) => (
            <div key={i}>
              <WYSIWYG content={item.text} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ColourPdpBenefits
